export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="tiny"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="167.6 -0.5 624 561"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#ffffff"
        d="M645.9 560h-333c-15.6 0-28.1-12.5-28.1-28.1V329.3c0-7.5 3.1-15 8.1-20l166.5-166.5c11.2-11.2 29.3-11.2 39.9 0 l167.1 166.5c5.6 5.6 8.1 12.5 8.1 20l-0.6 202C673.9 546.9 661.5 560 645.9 560z"
      />
      <path
        fill="#ffffff"
        d="M782.4 290L500.6 8.7c-11.2-11.2-31.8-11.2-43 0L340.9 126V71.1c0-8.7-7.5-16.2-16.2-16.2h-45.5c-8.7 0-16.2 7.5-16.2 16.2 v133.5L176.9 290c-11.8 11.8-11.8 31.2 0 43c11.8 11.8 31.2 11.8 43 0L479.4 73.6l260 260c6.2 6.2 13.7 8.7 21.2 8.7 c7.5 0 15.6-3.1 21.2-8.7C794.3 321.2 794.3 301.8 782.4 290z"
      />
    </g>
  </svg>
);
